import { AuthenticationContext, adalFetch } from "react-adal";
import { InteractionRequiredAuthError,PublicClientApplication } from "@azure/msal-browser";

const tenantEnv = process.env.REACT_APP_TENANT;
const clientIdEnv = process.env.REACT_APP_CLIENT_ID;
const redirectUriEnv = process.env.REACT_APP_REDIRECT_URI;

let config = {
  tenant: tenantEnv,
  clientId: clientIdEnv,
  redirectUri: redirectUriEnv,
  cacheLocation: "sessionStorage"
};

export const msalConfig = {
  auth: {
    clientId: clientIdEnv,
    authority: `https://login.microsoftonline.com/${tenantEnv}`,
    redirectUri: redirectUriEnv,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const authContext = new AuthenticationContext(config);

export const getToken = async() => await getTokenAsync();

const account = msalInstance.getAllAccounts()[0];

export const msalApiFetch = async (axiosInstance, url, options = {}) => {
    try {
        const token = await getTokenAsync();
        const headers = {
            ...(options.headers || {}),
            Authorization: `Bearer ${token}`
        };
        const response = await axiosInstance(url, { ...options, headers });
        return response; 
    } catch (error) {
        console.error("Axios wrapper failed:", error);
        throw error;
    }
};
export const getUser = () => {
  const currentAccounts = msalInstance.getAllAccounts();
  return currentAccounts.length > 0 ? currentAccounts[0] : null;
};

export const getTokenAsync = async () => {
  const account = getUser();
  if (!account) {
    console.log("No active account found.")
    return
  }
  const tokenRequest = {
      scopes: [`${process.env.REACT_APP_CLIENT_ID}/user_impersonation`],
      account: account
  }
  try {
      const response = await msalInstance.acquireTokenSilent(tokenRequest);
      return response.accessToken;  
  } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
          try {
              const interactiveResponse = await msalInstance.acquireTokenPopup(tokenRequest);
              return interactiveResponse.accessToken;
          } catch (popupError) {
              throw popupError;
          }
      } else {
        console.log("Token error ",error)
          throw error;
      }
  }
};

export const logout = () => {
  const account = getUser();
  msalInstance.logoutRedirect({account: account,
      postLogoutRedirectUri: "/" 
  });
};
